import setSweepRuleUIUpdate from './setSweepRuleUIUpdate';
import setSweepRuleService from '../services/setSweepRuleService';
import SetSweepRuleOperation from 'owa-service/lib/contract/SetSweepRuleOperation';
import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
import store from '../store/store';
import EwsSweepRule from 'owa-service/lib/contract/EwsSweepRule';

/**
 * Saves the current sweep rule configuration
 */
export default action('setSweepRule', datapoints.setSweepRule)(function setSweepRule(
    sweepRuleId: string,
    sweepOperation: SetSweepRuleOperation
) {
    // store information about the sweep rule to operate on, if the request fails we need to revert the UI
    const ruleIdIndex = store.sweepRuleIds.indexOf(sweepRuleId);
    const rule = store.sweepRules.get(sweepRuleId);

    setSweepRuleUIUpdate(sweepRuleId, sweepOperation);

    return setSweepRuleService(sweepRuleId, sweepOperation)
        .then(response => {
            if (response.Body.ResponseMessages.Items[0].ResponseClass != 'Success') {
                // revert UI on failure
                revertSweepRuleUI(sweepOperation, rule, sweepRuleId, ruleIdIndex);
            }
        })
        .catch(error => {
            // revert UI on failure
            revertSweepRuleUI(sweepOperation, rule, sweepRuleId, ruleIdIndex);
        });
});

function revertSweepRuleUI(
    sweepOperation: SetSweepRuleOperation,
    rule: EwsSweepRule,
    ruleId: string,
    ruleIdIndex: number
) {
    if (sweepOperation == SetSweepRuleOperation.Delete) {
        store.sweepRules.set(ruleId, rule);
        store.sweepRuleIds.splice(ruleIdIndex, 0, ruleId);
    } else {
        // other sweep rule operations are enable/disable
        rule.IsEnabled = !rule.IsEnabled;
    }
}
